// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsEventController from "./analytics_event_controller"
application.register("analytics-event", AnalyticsEventController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CookingModeController from "./cooking_mode_controller"
application.register("cooking-mode", CookingModeController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import ExtractionStatusController from "./extraction_status_controller"
application.register("extraction-status", ExtractionStatusController)

import PosthogResetController from "./posthog_reset_controller"
application.register("posthog-reset", PosthogResetController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)
